import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { debounce } from 'lodash';
import { getTrip } from 'redux/actions/UserTrip';
import { dateFormate } from 'utils/utils';
import RideTrackTab from './RideTrackTab';
import { filterRideTrackdata } from './RideTrackData';

export default function RideTrack() {
  const tripStatus = JSON.parse(localStorage.getItem('tripStatus'))
  const {state} = useLocation() || {};
  let rideTrackStatus = state?.rideTrackStatus
  const [searchParams, setSearchParams] = useSearchParams();
  const startDate = searchParams?.get('startDate');
  const endDate = searchParams?.get('endDate');
  const filterPage = searchParams?.get('page');
  const filterRowPerPage = searchParams?.get('rowPerPage');
  const filterSearch = searchParams?.get('search');
  const filterStatustatus = searchParams?.get('status');
  const {tabs} = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [value, setValue] = useState('1');
  const [page, setPage] = useState(filterPage ? parseInt(filterPage) : 0);
  const [rowsPerPage, setRowsPerPage] = useState(filterRowPerPage ? filterRowPerPage : 10);
  const [dateFrom, setDateFrom] = useState(startDate && startDate !== 'null'
  ? startDate
  : startDate === 'null'
  ? ''
  : state?.fromTab
  ? state?.dateFrom
  : dateFormate(new Date(),"MM/DD/YYYY"));
  const [dateTo, setDateTo] = useState(endDate && endDate !== 'null'
  ? endDate
  : endDate === 'null'
  ? ''
  : state?.fromTab
  ? state?.dateTo
  : dateFormate(new Date(),"MM/DD/YYYY"));
  const [status, setStatus] = useState(tripStatus?.length > 0 ? tripStatus : rideTrackStatus?.length > 0 ? [rideTrackStatus] : "");
  const [search, setSearch] = useState(filterSearch ? filterSearch : '');
  const [type, setType] = useState("ride");
  const tableData = useSelector((state) => state?.userTrip?.userTrip?.data);
  const loader = useSelector((state) => state?.userTrip?.loading);
  let filterData =  {
    id: "",
    page:page,
    dateFrom:dateFrom,
    dateTo:dateTo,
    status:status,
    pageSize:rowsPerPage,
    type:type, 
    search:search
  }

  let paramsList = {};

  searchParams.forEach((value, key) => {
    paramsList[key] = value;
  });

  const businessType = localStorage.getItem('businessType')
  useEffect(() => {
    if(businessType === 'isB2B' && tabs === '1'){
      navigate(`/rideTrack/2`)
      window.location.reload()
    } else if(businessType === 'isB2C' && tabs === '4'){
      navigate(`/rideTrack/1`)
      window.location.reload()
    }
  }, [])

  useEffect(() => {
    if(tabs == '2'){
      setType('rental')
      dispatch(getTrip({...filterData, type:'rental'}));
    }else if(tabs == '3'){
      setType('airport')
      dispatch(getTrip({...filterData, type:'airport'}));
    }else if(tabs == '4'){
      setType('outstation')
      dispatch(getTrip({...filterData, type:'outstation'}));
    }else{
      setType('ride')
      dispatch(getTrip({...filterData, type:'ride'}));
    }
    setValue(tabs);
  }, []);

  const handleChange = (newValue,) => {
    localStorage.removeItem('tripStatus')
    navigate(`/rideTrack/${newValue}`)
    setStatus([])
    setSearch('')
    if(newValue == '2'){
      setType('rental')
      dispatch(getTrip({...filterData, type:'rental',status:'',search:''}));
    }else if(newValue == '3'){
      setType('airport')
      dispatch(getTrip({...filterData, type:'airport',status:'',search:''}));
    }else if(newValue == '4'){
      setType('outstation')
      dispatch(getTrip({...filterData, type:'outstation',status:'',search:''}));
    }else{
      setType('ride')
      dispatch(getTrip({...filterData, type:'ride',status:'',search:''}));
    }
    setValue(newValue);
  };

  const handleChangePage = (newPage) => {
    setSearchParams({ ...paramsList, page: newPage });
    setPage(newPage);
    dispatch(getTrip({...filterData, page:newPage}))
  };
  const handleChangeRowsPerPage = (event) => {
    setSearchParams({
      ...paramsList,
      rowPerPage: parseInt(event.target.value),
      page: 0,
    });
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(getTrip({...filterData, page:0, pageSize:parseInt(event.target.value)}))
  };

  const onClickTableVendor = (data) => {
    localStorage.setItem('tripStatus', JSON.stringify(status))
    let url = window.location.pathname.split("/")[1]
    if (url === 'rideTrack' && businessType === 'isB2C'){
      navigate('/rideTrack/details', {state: {id: data?.id, status: data?.status, customer: data?.customerName, driver: data?.driverName, type, tripId: data?.tripId }})
    } else if(url === 'rideTrack' && businessType === 'isB2B'){
      navigate(`/rideTrack/bookingdetails?id=${data.id}&startDate=${dateFrom}&endDate=${dateTo}&status=${status}&search=${search}&page=${page}&rowPerPage=${rowsPerPage}&tab=${tabs}`, {state: {id: data?.id}})
    }
  }

  const onFilterChange = (val) => {
    rideTrackStatus = ""
    localStorage.removeItem('tripStatus')
    setStatus(val);
    setPage(0);
    setSearchParams({ ...paramsList, status: val?.toString() });
    filterData = {...filterData, status:val.toString(), page: 0}
    dispatch(getTrip(filterData));
  }

  const onRestFilter = () => {
    rideTrackStatus = ''
    localStorage.removeItem('tripStatus')
    setStatus("")
    setSearchParams({ ...paramsList, status: '' });
    filterData = {...filterData, status:""}
    dispatch(getTrip(filterData));
  }

  const onSelectDateRange = (newValue) => {
    if(newValue === null || newValue === 0){
      setSearchParams({ ...paramsList, startDate: 'null', endDate: 'null' });
      setDateFrom('')
      setDateTo('')
      filterData = {...filterData, 
        dateFrom:'',
        dateTo:''
      }
    }else{
      setSearchParams({
        ...paramsList,
        startDate:dateFormate(newValue[0], "MM/DD/YYYY"),
        endDate:dateFormate(newValue[1],"MM/DD/YYYY")
      })
      setDateFrom(dateFormate(newValue[0],"MM/DD/YYYY"))
      setDateTo(dateFormate(newValue[1],"MM/DD/YYYY"))
      filterData = {...filterData, 
        dateFrom:dateFormate(newValue[0],"MM/DD/YYYY"),
        dateTo:dateFormate(newValue[1],"MM/DD/YYYY")
      }
    }
    dispatch(getTrip(filterData));
  }

  const onSearch = debounce((e) =>{
    setSearchParams({ ...paramsList, page: 0, search: e });
    setSearch(e)
    setPage(0);
    filterData = {
     ...filterData,search:e, pageSize:'', page:0
    }
    dispatch((getTrip(filterData)))
   },1000)

  return (
    <div>
      <RideTrackTab 
        defaultStatus={status}
        filterData={filterRideTrackdata}
        rideTrackData={tableData} 
        onClickTableVendor={onClickTableVendor} 
        handleChange={handleChange}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        value={value} 
        page={page} 
        rowsPerPage={rowsPerPage} 
        onFilterChange={onFilterChange} 
        onRestFilter={onRestFilter} 
        onSelectDateRange={onSelectDateRange}
        loader={loader}
        onSearch={onSearch}
        tabName={'rideTrack'}
        dateFrom={dateFrom}
        dateTo={dateTo}
        search={search}
      />
    </div>
  )
}